import { render, staticRenderFns } from "./mainview.vue?vue&type=template&id=027e644c&scoped=true&lang=html"
import script from "./mainview.vue?vue&type=script&lang=js"
export * from "./mainview.vue?vue&type=script&lang=js"
import style0 from "./mainview.vue?vue&type=style&index=0&id=027e644c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e644c",
  null
  
)

export default component.exports